"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasProperty = void 0;
/**
 * Ensures a object has a given property.
 *
 * Based on https://fettblog.eu/typescript-hasownproperty/
 */
function hasProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
exports.hasProperty = hasProperty;
//# sourceMappingURL=hasProperty.js.map